import React from 'react';
import { ImageProps, ImageSourcePropType } from 'react-native';

import masterCardImage from '@assets/images/mastercard.svg';
import visaImage from '@assets/images/visa.svg';
import { CardFlag as CardFlagTypes } from '@constants/card';

import { CardFlagImage } from './styles';

const flagImageMapper: { [key in CardFlagTypes]: ImageSourcePropType } = {
  MASTERCARD: masterCardImage,
  VISA: visaImage
};

interface CardFlagProps extends Omit<ImageProps, 'source'> {
  flag: CardFlagTypes;
  source?: ImageSourcePropType;
}

const CardFlag: React.FC<CardFlagProps> = ({ flag, ...rest }) => {
  return <CardFlagImage {...rest} source={flagImageMapper[flag]} />;
};

export default CardFlag;
